import { createSelector } from 'reselect';

import { TopicReducer } from 'state/reducers/topic';
import { GlobalState, OrganizedTopic } from 'types';

export default createSelector(
  (state: GlobalState) => state.topic,
  (topic: TopicReducer): OrganizedTopic => {
    const topics = topic.topicLinksInArray;
    const organizedTopics: OrganizedTopic = {
      topics,
      topicsBySlug: {},
      topicsById: {},
      topicsByParentSlug: {},
    };

    topics.forEach((topic) => {
      organizedTopics.topicsBySlug[topic.slug] = topic;
      organizedTopics.topicsById[topic.id] = topic;
    });

    const topicsByParentSlug = organizedTopics.topicsByParentSlug;

    topics.forEach((topic) => {
      if (!topic.parentTopicId) {
        const rootTopic = topicsByParentSlug['/root'];

        if (rootTopic) {
          topicsByParentSlug['/root'] = rootTopic.concat([topic]);
        } else {
          topicsByParentSlug['/root'] = [topic];
        }
      } else {
        const parentSlug = organizedTopics.topicsById[topic.parentTopicId].slug;
        const currentTopicsByParentSlug = topicsByParentSlug[parentSlug];

        if (currentTopicsByParentSlug) {
          topicsByParentSlug[parentSlug] = currentTopicsByParentSlug.concat([
            topic,
          ]);
        } else {
          topicsByParentSlug[parentSlug] = [topic];
        }
      }
    });

    return organizedTopics;
  }
);
